<script>
import AiDiagnosis from "./AiDiagnosis.vue";

export default {
  name: "s-zlifepet-diagnostico",

  inject: ["hdl"],
  components: { AiDiagnosis },

  emits: [
    "update:anamnese",
    "update:exames-clinicos",
    "close",
    "aplicar",
  ],

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    maximize: {
      type: Boolean,
      default: true,
    },
    width: {
      type: Number,
      default: 950,
    },
    height: {
      type: Number,
      default: 600,
    },
    anamnese: {
      type: String,
    },
    examesClinicos: {
      type: String,
    },
    animalId: {
      type: [String, Number],
    },
  },
};
</script>

<template>
  <s-janela :dad="hdl" bt-mi bt-ma :maximize="maximize" :visible="visible"
    title="Assistente IA Zlife Pet" :width="width" :height="height"
    @close="$emit('close')">
    <ai-diagnosis :anamnese="anamnese" :exames-clinicos="examesClinicos"
      :animal-id="animalId" @update:anamnese="$emit('update:anamnese', $event)"
      @update:exames-clinicos="$emit('update:exames-clinicos', $event)"
      @close="$emit('close')"
      @aplicar="$emit('aplicar', $event)"></ai-diagnosis>
  </s-janela>
</template>

<style scoped>

</style>